// -- MUI -- //
import Stack from '@mui/material/Stack';
import type { ScheduledTransactionType } from 'app-components/flux/scheduled-transactions/scheduledTransactionsTypes';
import { tagsActions, tagsSelectors } from 'app-components/flux/tags';
import type { Tag } from 'app-components/flux/tags/tagsTypes';
import type { TransactionProps } from 'app-components/flux/transactions/transactionsTypes';
import { useAppDispatch, useAppSelector } from 'hooks/redux';
import type { List as ImList } from 'immutable';
// -- CORE -- //
import React from 'react';
// -- LOCAL -- //
import CategoriesSettings from './CategoriesSettings';
import TagsSettings from './TagsSettings';

export function CategoriesTagsSettings() {
  const dispatch = useAppDispatch();
  const getTags = () => dispatch(tagsActions.getTags());
  const createTag = (data: Tag) => dispatch(tagsActions.createTag(data, { undo: { userMessage: 'Tag created.' } }));
  const updateTag = (data: Tag) => dispatch(tagsActions.updateTag(data, { undo: { userMessage: 'Tag updated.' } }));
  const deleteTag = (
    data: Tag,
    txns?: ImList<Immutable.RecordOf<TransactionProps>>,
    schedTxns?: ImList<Immutable.RecordOf<ScheduledTransactionType>>,
  ) =>
    // @ts-expect-error not sure if this is needed - err 'Object literal may only specify known properties, and txns does not exist in type BaseResource'
    dispatch(tagsActions.deleteTag(data, { undo: { userMessage: 'Tag deleted.' }, txns, schedTxns }));

  const tags = useAppSelector(tagsSelectors.getTags);
  const tagsIsLoading = useAppSelector(tagsSelectors.getIsLoading);

  return (
    <Stack gap={1}>
      <TagsSettings
        isLoading={tagsIsLoading}
        data={tags}
        getItems={getTags}
        createItem={createTag}
        updateItem={updateTag}
        deleteItem={deleteTag}
      />
      <CategoriesSettings />
    </Stack>
  );
}

export default CategoriesTagsSettings;
